import React from 'react';
import { ScrollArea } from '@mantine/core';
import { InputMask, useGuidanceHooks } from '@shakkerai/pro-guidance';

const scrollAreaStyles = { root: {}, viewport: { paddingBottom: 14 } };

export const PanelWrapper = React.memo(({ icon, label, footer, children }) => {
  const { visible: guidanceVisible } = useGuidanceHooks(['Enter', 'ChooseStyle', 'Generate']);
  const { visible: guidanceEnterVisible } = useGuidanceHooks(['Enter']);

  return (
    <div className="w-[300px] flex-1 flex relative flex-col z-10 overflow-hidden">
      {label && (
        <div className="flex items-center flex-shrink-0 mt-4 px-[14px] z-10">
          <div className="flex items-center text-[#101010]">
            {!!icon && <img src={icon} className="w-[18px] h-[18px] mr-1" alt="" />}
            <span className="translate-y-[1px] font-extrabold text-base text-[#222] font-grotesk">{label}</span>
          </div>
          <div className="flex-1" />
        </div>
      )}
      <ScrollArea.Autosize
        scrollbars="y"
        scrollbarSize={8}
        className="flex-1 overflow-hidden"
        styles={scrollAreaStyles}
      >
        <div className="p-4"> {children}</div>
      </ScrollArea.Autosize>
      {footer}
      <InputMask visible={guidanceVisible} className={guidanceEnterVisible ? 'z-[19]' : 'z-[21]'}></InputMask>
    </div>
  );
});
